import { ExecutivesPage } from "~/components/marketing/executives";

export default function ForExecutivesRoute() {
  return <ExecutivesPage />;
}
